// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YjMrP","controls":"styles_controls__1PPwo","charLimit":"styles_charLimit__lWxi0","input":"styles_input__oHi9X","send":"styles_send__1hK8i"};